import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestBicos({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'bicos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deleteBico({ payload }) {
  try {
    const { idbico, params } = payload;

    yield call(api.delete, `bicos/${idbico}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(t(e)));
    else toast.error(t(erros));
  }
}

export function* store({ payload }) {
  try {
    const { bico, params } = payload;

    yield call(api.post, 'bicos', bico);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/bicos');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { id } = payload;

    const { data } = yield call(api.get, `bicos/${id}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* update({ payload }) {
  try {
    const { bico, params } = payload;

    yield call(api.put, 'bicos', bico);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/bicos');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'bicos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest('@bico/BICOS_IN_REQUEST', requestBicos),
  takeLatest('@bico/DELETE_BICO', deleteBico),
  takeLatest('@bico/SUCCESS_REMOVE', requestBicos),
  takeLatest('@bico/STORE_BICO', store),
  takeLatest('@bico/FIND_BICO', find),
  takeLatest('@bico/UPDATE_BICO', update),
  takeLatest('@bico/RECORD_FILTERING', applyedFilters),
  takeLatest('@bico/RECORD_FILTERINGBlOQUEIO', applyedFilters),
]);
